// src/HomeTwoScreen.js

import React, { useEffect } from "react";
import ProcessAreaStep from "../components/ProcessAreaStep";
import FanFacetCol from "../components/FanFacetCol";
import Accordion from "../components/ui/accordion";
import FAQAccordion from "../components/ui/FAQAccordion";
import TestimonialsSlider from "../components/TestimonialsSlider";
import { Link } from "react-router-dom";
import { IMAGES } from "../assets/img/ImageIndex";
import MortgageCalculatorForm from "../components/MortgageCalculatorForm";
import WhyUsArea from "../components/WhyUsArea";
import TrustpilotInitializer from "../components/TrustpilotWidget/TrustpilotInitializer";

function HomeTwoScreen() {
  useEffect(() => {
    // Set document title and meta tags
    document.title = 'Small Business Loans in the USA | Flexible Funding by EnvoCapital';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'EnvoCapital helps growing businesses access small business loans, working capital, and fast funding across the USA. Flexible approvals, simple process, real support. Let\'s fund your next stage of growth.');
    }

    // Add Schema.org structured data to head
    const structuredData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "FinancialService",
          "@id": "https://envocapital.com/#financialservice",
          "name": "EnvoCapital",
          "url": "https://envocapital.com/",
          "description": "EnvoCapital provides business financing solutions including small business loans, working capital loans, and flexible funding options for businesses in the United States.",
          "telephone": "+1-800-371-5360",
          "email": "info@envocapital.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "12864 Biscayne Blvd #1018",
            "addressLocality": "North Miami",
            "addressRegion": "FL",
            "postalCode": "33181",
            "addressCountry": "US"
          },
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday"
              ],
              "opens": "10:00",
              "closes": "18:00"
            }
          ],
          "areaServed": {
            "@type": "Country",
            "name": "United States"
          },
          "serviceType": [
            "Small Business Loans",
            "Business Financing",
            "Working Capital Loans",
            "Short Term Business Loans",
            "Business Credit Lines",
            "Equipment Financing",
            "Accounts Receivable Financing"
          ],
          "sameAs": [
            "https://www.instagram.com/envo.capital/"
          ]
        },
        {
          "@type": "WebSite",
          "@id": "https://envocapital.com/#website",
          "url": "https://envocapital.com/",
          "name": "EnvoCapital",
          "publisher": {
            "@id": "https://envocapital.com/#financialservice"
          },
          "inLanguage": "en-US"
        },
        {
          "@type": "WebPage",
          "@id": "https://envocapital.com/#webpage",
          "url": "https://envocapital.com/",
          "name": "EnvoCapital | Business Financing USA",
          "isPartOf": {
            "@id": "https://envocapital.com/#website"
          },
          "about": {
            "@id": "https://envocapital.com/#financialservice"
          },
          "inLanguage": "en-US"
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://envocapital.com/#breadcrumbs",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://envocapital.com/"
            }
          ]
        }
      ]
    };

    // Create script element
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData, null, 2);
    
    // Add to head
    document.head.appendChild(script);

    // Cleanup on unmount
    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);
  return (
    <div className="page-area mt-80">
        <div id="post-196" className="post-196 page type-page status-publish hentry">
            <div className="entry-content">
                <div data-elementor-type="wp-page" data-elementor-id="196" className="elementor elementor-196">
                    <div className="banner-area banner-bg-2">
                        <div className="container mw-1380 pb-130">
                            <div className="row">
                                <div className="col-lg-7">
                                    <div className="banner-content style-two">
                                        <h1 className="title">Elevate Business, Experience Excellence </h1>
                                        <p>At EnvoCapital, we know every business is unique.</p>
                                        <div className="banner-btn d-flex align-items-center">
                                            <Link to="https://app.envocapital.com" className="btn btn-dark border-0" target="_blank">
                                                Apply Now
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-5">
                                    <MortgageCalculatorForm/>
                                </div>
                            </div>
                        </div>
                        <div className="container mw-1570">
                            <div className="banner-img">
                                <img decoding="async" src={IMAGES.banner4} alt="banner4"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="about-us-area bg-gray2 ptb-130 border-start border-end position-relative z-1">
                    <div className="container mw-1380">
                        <div className="about-us-content">
                            <p>At EnvoCapital, we genuinely care about what’s best for your business. From application to approval, our goal is to provide exceptional service while helping you save more. We offer fully customized business loan solutions, finding the right program and most favorable terms for your needs. Our success is built on the trust of our clients and partners, who rely on us every day to guide and support them through the business loan process.</p>
                            <div className="row align-items-center">
                                <div className="col-lg-7">
                                    <div className="me-63">
                                        <div className="row">
                                            <div className="col-lg-6 col-sm-6">
                                                <FanFacetCol count={'78%'} title="Business from Referrals" duration={1000}/>
                                            </div>
                                            <div className="col-lg-6 col-sm-6">
                                                <FanFacetCol count={'45+'} title="Minute Verbal Commitment" duration={1000}/>
                                            </div>
                                        </div>

                                        <div className="popular-clients-wrap mb-4 mb-lg-0">
                                            <div className="row align-items-center">                                                
                                                <div className="col-lg-6 col-sm-6">
                                                    <Link to="/about-us/" className="read-more text-primary text-left d-block mt-3 mt-sm-0">
                                                        Know More About Us
                                                        <i className="fi fi-rs-arrow-right"></i>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-5 text-center text-lg-start">
                                    <div className="row align-items-center">
                                        <div className="col-lg-6 col-sm-6">
                                            <div className="about-img-1 mb-4 mb-sm-0">
                                                <img decoding="async" src={IMAGES.about1} alt="about1"/>
                                            </div>
                                        </div>

                                        <div className="col-lg-6 col-sm-6">
                                            <div className="about-img-2">
                                                <img decoding="async" src={IMAGES.about2} alt="about2"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img decoding="async" src={IMAGES.shape3} className="shape shape-3" alt="shape"/>
                </div>
                <div className="financing-area bg-gray2 pb-130">
                    <div className="container mw-1570">
                        <div className="financing-wrap">
                            <div className="section-title mw-760">
                                <h2 className="text-white">Securing a business loan can feel overwhelming, with so many financing options to choose from.</h2>
                            </div>
                            <div className="row align-items-end">
                                <div className="col-xl-6">
                                    <div className="financing-img-wrap">
                                        <div className="row align-items-center align-items-xl-start">
                                            <div className="col-lg-6 col-sm-6">
                                                <div className="financing-img">
                                                    <img decoding="async" src={IMAGES.financing1} className="rounded-pill" alt="financing1"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-sm-6">
                                                <div className="financing-img-2">
                                                    <img decoding="async" src={IMAGES.financing2} className="rounded-pill" alt="financing2"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-6">
                                    <div className="accordion financing" id="accordionExample">                                           
                                        <Accordion items={[
                                            {
                                                title: 'Revenue-Based Financing',
                                                content: <p>Flexible funding where repayments adjust with your business revenue, making it ideal for growing companies with fluctuating income.</p>
                                            },
                                            {
                                                title: 'SBA Loans',
                                                content: <p>Government-backed loans offering low interest rates and longer terms, making them perfect for small businesses seeking affordable growth capital.</p>
                                            },
                                            {
                                                title: 'Term Loans',
                                                content: <p>Get a lump sum upfront with fixed payments over time, making it great for financing large purchases or expansion projects.</p>
                                            },
                                            {
                                                title: 'Line of Credit',
                                                content: <p>Access funds anytime you need them, paying interest only on the amount you use to ensure smooth cash flow management.</p>
                                            }
                                        ]} />
                                    </div>

                                    <div className="view-all-program-loans d-none d-lg-block">
                                        <Link to="/loan-program/" className="read-more">
                                            View All Program Loans
                                            <i className="fi fi-rs-arrow-right"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="why-us-area pt-130">
                   <WhyUsArea />
                </div>
                <div className="fan-facet-area pt-130 pb-105">
                    <div className="container mw-1380">
                        <div className="d-sm-flex justify-content-lg-between justify-content-center gap-3 gap-lg-0 align-items-center flex-wrap">
                            <FanFacetCol count={'684+'} title="Businesses Empowered" duration={1000}/>
                            <FanFacetCol count={'10K+'} title="Business Loans Completed" duration={1000}/>
                            <FanFacetCol count={'10+'} title="Years of Excellence" duration={1000}/>
                            <FanFacetCol count={'100K+'} title="Successful Partnerships Worldwide" duration={1000}/>
                        </div>
                    </div>
                </div>
                <div className="process-area pb-130">
                    <div className="container mw-1380">
                        <div className="section-title">
                            <h2>EnvoCapital has a simple online process for loan applications</h2>
                        </div>

                        <ProcessAreaStep/>
                    </div>
                </div>
                <div className="team-member-area pb-105">
                    <div className="review-on-area">
                        <div className="mw-1480">
                            <div className="review-on-bg bg-img" style={{backgroundImage: `url(${IMAGES.reviewOnBg})`}}>
                                <div className="container mw-1380">
                                    <div className="row align-items-center">
                                        <div className="col-lg-6">
                                            <div className="review-on-content">
                                                <h2>We help businesses achieve their goals with the right financing</h2>
                                                <p>Since business loans can be complex, we simplify the entire process so funding your growth becomes fast and hassle-free.</p>
                                            </div>
                                        </div>

                                        <div className="col-lg-3"></div>
                                        <div className="col-lg-3">
                                            <TrustpilotInitializer />
                                            <div className="trustpilot-area ptb-50">
                                                <div className="container mw-1380">
                                                    <div className="trustpilot-widget" data-locale="en-US" data-template-id="56278e9abfbbba0bdcd568bc" data-businessunit-id="690113cac950f88c5e42695e" data-style-height="52px" data-style-width="100%" data-token="cd1c4eee-e439-4849-81bf-ff5061243140">
                                                        <a href="https://www.trustpilot.com/review/envocapital.com" target="_blank" rel="noopener">Trustpilot</a>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="review-on-point d-sm-flex justify-content-between align-items-center">
                                                <Link to="https://www.trustpilot.com/users/69162128ef3d6c8579c3f989" target="_blank" className="no-underline">
                                                    <div className="d-flex align-items-center mb-1">
                                                        <span className="title">Review On</span>
                                                        <img decoding="async" src={IMAGES.stars45} className="stars" alt="stars45"/>
                                                    </div>
                                                    <div className="d-flex align-items-center">
                                                        <img decoding="async" src={IMAGES.trast} className="trast" alt="trast"/>

                                                        <span className="title2">100+ Reviews</span>
                                                    </div>
                                                </Link>                                                
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="testimonials-area">
                        <div className="container mw-1380">
                            <TestimonialsSlider/>
                        </div>
                    </div>
                </div>
                <div className="faq-area pb-130">
                    <div className="container mw-1380">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="faq-img">
                                    <img decoding="async" src={IMAGES.faq} alt="faq"/>
                                    <Link to="/contact-us/" className="read-more">
                                        Contact With Us
                                        <i className="fi fi-rs-arrow-right"></i>
                                    </Link>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="faq-content">
                                    <h2>Find Answers to Your Business Funding Questions</h2>
                                </div>
                                <FAQAccordion items={[
                                    {
                                        title: 'Who is EnvoCapital?',
                                        content: (
                                            <p>EnvoCapital is a leading provider of specialized financial solutions designed to help small and medium-sized businesses reach their full potential.
                                            </p>
                                        )
                                    },
                                    {
                                        title: 'How Can EnvoCapital Help My Business?',
                                        content: (
                                            <p>EnvoCapital provides customized financing options, including flexible loans and lines of credit tailored to your needs. With expert guidance and continuous support, we help your business thrive and succeed.
                                            </p>
                                        )
                                    },
                                    {
                                        title: 'What Financial Solutions Does EnvoCapital Offer?',
                                        content: (
                                            <p>EnvoCapital offers flexible term loans, lines of credit, and creative, customized financing solutions tailored to your business needs.
                                            </p>
                                        )
                                    },
                                    {
                                        title: 'What can I use the funding towards?',
                                        content: (
                                            <p>EnvoCapital allows flexibility in the use of funds, provided they are for legitimate business purposes.
                                            </p>
                                        )
                                    },
                                    {
                                        title: 'Do I need to provide securities to qualify?',
                                        content: (
                                            <p>No, EnvoCapital offers unsecured loans. In certain cases, EnvoCapital may secure our financing with a general lien on your business assets and/ or a personal guarantee. However, rest assured, your personal assets are not used as collateral. We priorities businesses which have business revenue more than $300K.
                                            </p>
                                        )
                                    },
                                    {
                                        title: 'Can I qualify for a business loan or line of credit if I have bad credit?',
                                        content: (
                                            <p>Absolutely! Each applicant is considered on a case-by-case basis. Even with bad credit, you can still qualify for a business loan or line of credit. We consider your overall business health, not just your credit score.
                                            </p>
                                        )
                                    }
                                ]} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default HomeTwoScreen;
